import React from 'react';

import messages from './messages';
import FulfillmentPlanActivityContainer from '../../../../../fulfillment-plans/activity/container';
import { useFulfillmentPlanIdContext } from '../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import SectionTitle from '../../../tab-section/title';
import { OrderDetailsSectionId } from '../../order-details-expanded-section-provider';

import style from './shipment-activity.module.less';

const sectionPendoTrackingId = 'order-details/fp-section-header-activity';

const ShipmentActivity = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style['shipment-activity-section-content']}
      headerContent={<SectionTitle messageDescriptor={messages.shipmentActivitySectionTitle} />}
      pendoTrackingId={sectionPendoTrackingId}
      sectionContent={
        <FulfillmentPlanActivityContainer className={style['fulfillment-plan-activity-list']} fulfillmentPlanId={fulfillmentPlanId} />
      }
      sectionId={OrderDetailsSectionId.ShipmentActivity}
    />
  );
};

export default ShipmentActivity;
